const Radio = ({ actived, onClick, children, className }) => {
  const getRadioClassNames = () => {
    let baseClassName = "p-4 border-[1.5px] transition-colors duration-300 ";
    if (actived) {
      baseClassName += "border-primary bg-[#1B51EC1A] ";
    } else {
      baseClassName += "border-[#1B51EC33] bg-[#FFFFFF80] ";
    }
    baseClassName += className ? ` ${className} ` : "";
    return baseClassName;
  };

  return (
    <button type="button" className={getRadioClassNames()} onClick={onClick}>
      {children}
    </button>
  );
};

export default Radio;
